export default __webpack_public_path__ + "static/media/SuperRare.9b3961f8.svg";